import { SvgIcon } from '../svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from '../svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 256 256',
    defaultAriaLabel: 'Home Icon',
};

export const HomeIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <circle cx="128.5" cy="128.5" r="90.5" fill="#EAF7FA" />
            <path
                d="M216.5 128.5C216.5 79.8989 177.101 40.5 128.5 40.5C79.8989 40.5 40.5 79.8989 40.5 128.5C40.5 177.101 79.8989 216.5 128.5 216.5C177.101 216.5 216.5 177.101 216.5 128.5ZM221.5 128.5C221.5 179.862 179.862 221.5 128.5 221.5C77.1375 221.5 35.5 179.862 35.5 128.5C35.5 77.1375 77.1375 35.5 128.5 35.5C179.862 35.5 221.5 77.1375 221.5 128.5Z"
                fill="#00A2BA"
            />
            <path
                d="M144.375 173.5H179.5V110.182L168.498 101.914C167.87 101.442 167.5 100.701 167.5 99.915V79.5H156.5V87.8916C156.5 88.8388 155.965 89.7046 155.117 90.1279C154.27 90.5511 153.255 90.4596 152.498 89.8906L128.5 71.8564L77.5 110.182V173.5H112.625V145.409C112.625 136.629 119.727 129.5 128.5 129.5C137.273 129.5 144.375 136.629 144.375 145.409V173.5ZM184.5 174.915C184.5 176.889 182.901 178.5 180.917 178.5H142.958C140.974 178.5 139.375 176.889 139.375 174.915V145.409C139.375 139.378 134.5 134.5 128.5 134.5C122.5 134.5 117.625 139.378 117.625 145.409V174.915C117.625 176.889 116.026 178.5 114.042 178.5H76.083C74.0985 178.5 72.5002 176.889 72.5 174.915V109.476C72.5001 108.349 73.0294 107.286 73.9316 106.608L126.349 67.2187C127.544 66.3208 129.16 66.264 130.407 67.0498L130.651 67.2187L151.5 82.8847V77C151.5 75.6192 152.619 74.5 154 74.5H170C171.381 74.5 172.5 75.6192 172.5 77V98.666L183.068 106.608C183.971 107.286 184.5 108.349 184.5 109.476V174.915Z"
                fill="#00A2BA"
            />
        </SvgIcon>
    );
};
